// UAT Environment
export const environment = {
  production: true,
  envName: 'uat',
  version: '1.0.0-uat',
  apiUrl: 'https://atp-api.dev-bu.com/api',
  
  // Google Gemini AI
  geminiApiKey: 'AIzaSyCsSI7L4wD4S5nEP9CO02z4d68bE04Hmfg',
  
  // OAuth Configuration
  oauth: {
    google: {
      clientId: '770511309696-tmg1ih1tjjoel4i9iuu8jggn2g03b18v.apps.googleusercontent.com',
    },
    facebook: {
      appId: '1648894182968948',
    },
    line: {
      clientId: 'YOUR_LINE_CLIENT_ID',
      liffId: 'YOUR_LINE_LIFF_ID',
      redirectUri: 'https://atp.dev-bu.com/auth/callback',
    }
  }
};
